import React, { useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import LoadingScreen from 'src/components/LoadingScreen';
import { useSaldoContratoController, SaldoContrato } from 'src/controllers/Contrato/SaldoContratoController';

const fmt = (value: number | null) =>
    value != null
        ? Number(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        : '-';

const ContratosSaldo: React.FC = () => {
    const { data, loading, fetchSaldo } = useSaldoContratoController();
    const [globalFilter, setGlobalFilter] = useState('');

    if (loading) return <LoadingScreen />;

    const valorTemplate = (row: SaldoContrato) => fmt(row.VALOR);
    const totalTemplate = (row: SaldoContrato) => fmt(row.TOTAL_FATURADO);
    const saldoTemplate = (row: SaldoContrato) => (
        <span style={{ color: row.SALDO >= 0 ? '#22c55e' : '#ef4444', fontWeight: 600 }}>
            {fmt(row.SALDO)}
        </span>
    );
    const percTemplate = (row: SaldoContrato) => {
        if (!row.VALOR) return '-';
        const perc = (row.TOTAL_FATURADO / row.VALOR) * 100;
        return `${perc.toFixed(1)}%`;
    };

    const header = (
        <div className="table-header p-grid p-d-flex p-jc-between p-ai-center">
            <h5 className="p-m-0">Saldo de Contratos</h5>
            <div className="p-d-flex p-ai-center" style={{ gap: '0.5rem' }}>
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText
                        type="search"
                        value={globalFilter}
                        onChange={e => setGlobalFilter(e.target.value)}
                        placeholder="Buscar..."
                    />
                </span>
                <Button
                    icon="pi pi-refresh"
                    className="p-button-outlined"
                    tooltip="Atualizar"
                    onClick={fetchSaldo}
                />
            </div>
        </div>
    );

    return (
        <div className="p-card p-p-4 datatable-container">
            <DataTable
                header={header}
                value={data}
                globalFilter={globalFilter}
                rowHover
                className="responsive-table p-datatable-sm"
                dataKey="ID"
                autoLayout
                scrollable
                scrollHeight="100%"
                emptyMessage="Nenhum contrato encontrado."
            >
                <Column field="NUMERO" header="NÚMERO" sortable />
                <Column field="DESCRICAO" header="DESCRIÇÃO" sortable />
                <Column field="VALOR" header="VALOR DO CONTRATO" body={valorTemplate} sortable />
                <Column field="TOTAL_FATURADO" header="TOTAL FATURADO" body={totalTemplate} sortable />
                <Column field="SALDO" header="SALDO DISPONÍVEL" body={saldoTemplate} sortable />
                <Column header="% UTILIZADO" body={percTemplate} />
            </DataTable>
        </div>
    );
};

export default ContratosSaldo;
